import React from "react";
import './index.scss';
import download from "../../images/download.svg";
import {ReactSVG} from "react-svg";

export interface DownloadLinkData {
    label: string
    url: string
    mimeType: string
}

interface UsefullInfoProps {
    title: string
    items: DownloadLinkData[]
}

export const UsefullInfo = ({title, items}: UsefullInfoProps) =>
    <div className='usefull-info'>
        <h3 className="usefull-info__header">{title}</h3>
        <div className="usefull-info__list">
            {items.map((item, idx) =>
                <a key={`option-${item.mimeType}-${idx}`}
                   className="usefull-info__list__item"
                   href={item.url}
                   target="_blank">
                    <ReactSVG src={download}/>
                    <div className="usefull-info__list__item__info">
                        <div className="usefull-info__list__item__label">{item.label}</div>
                        <div className="usefull-info__list__item__mime">{item.mimeType}</div>
                    </div>
                </a>)}
        </div>
    </div>